import { HttpClient } from '@angular/common/http'
import { inject, Injectable } from '@angular/core'
import { Observable } from 'rxjs'
import { NavigationStats } from '../interfaces/me/navigation-stats.interface'

@Injectable({
    providedIn: 'root',
})
export class StatsService {
    #httpClient = inject(HttpClient)

    getNavigationStats(): Observable<NavigationStats> {
        return this.#httpClient.get<NavigationStats>(`/api/stats/navigation`)
    }
}
